import './App.css';
import React, { useEffect} from "react";
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";

import Footer from "./components/inc/Footer";
import Doctorpage from './components/pages/Doctorpage';
import Labtest from './components/pages/Labtest';
import About from './components/pages/About';
import Contactus from './components/pages/Contactus';
import Radiology from './components/pages/Radiology';
import Xray from './components/pages/Xray';
import Labpage from './components/pages/Labpage';
import Radiologypage from './components/pages/Radiologypage';
import Usg from './components/pages/Usg';
import Ctscan from './components/pages/Ctscan';
import Mri from './components/pages/Mri';
import Opg from './components/pages/Opg';
import Healthpackage from './components/pages/Healthpackage';

function App() {
  return (
<Router>
      
  
     
    <div>
  
     
      
      <Routes>
 
     
      <Route axact path="/" element={<Home/>}/>
       <Route axact path="/find-doctor" element={<Doctorpage/>}/>
        <Route axact path="/labtest" element={<Labpage/>}/>
           <Route axact path="/about-us" element={<About/>}/>
              <Route axact path="/contact-us" element={<Contactus/>}/>
                  <Route axact path="/Radiology" element={<Radiologypage/>}/>
                     <Route axact path="/xray" element={<Xray/>}/>
                             <Route axact path="/usg" element={<Usg/>}/>
                              <Route axact path="/ct-scan" element={<Ctscan/>}/>
                              <Route axact path="/mri" element={<Mri/>}/>
                                 <Route axact path="/opg" element={<Opg/>}/>
                                    <Route axact path="/healthpackage" element={<Healthpackage/>}/>
         </Routes>
    <Footer/>
  
    </div>
   
    </Router>
  );
}

export default App;
